import * as yup from 'yup';

export const UtensilsSchema = yup.object({
  aid: yup.string().required(),
  deliveryDate: yup.date().notRequired().nullable(),
  pickupDate: yup.date().notRequired().nullable(),
  lastTestDate: yup.date().notRequired().nullable(),
  number: yup.string().notRequired().nullable(),
  serialNumber: yup.string().notRequired().nullable(),
  medicalSupplyStore: yup.string().notRequired().nullable(),
  location: yup.string().notRequired().nullable(),
});

export interface IUtensils {
  aid: string;
  deliveryDate?: Date;
  pickupDate?: Date;
  lastTestDate?: Date;
  number?: string;
  serialNumber?: string;
  medicalSupplyStore?: string;
  location?: string;
}

export const CreateUtensilsSchema = yup
  .object({
    residentId: yup.string(),
  })
  .concat(UtensilsSchema);

export interface ICreateUtensils extends IUtensils {
  residentId: string;
}

export const UpdateUtensilsSchema = yup
  .object({
    id: yup.string(),
  })
  .concat(UtensilsSchema);

export interface IUpdateUtensils {
  id: string;
  aid: string;
  deliveryDate?: Date;
  pickupDate?: Date;
  lastTestDate?: Date;
  number?: string;
  serialNumber?: string;
  medicalSupplyStore?: string;
  location?: string;
}
